module.exports = __webpack_public_path__ + "img/hyphen.7455bf44.svg";